var React = require('react');

function Sun (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.549 4C9.196 3.99 4.033 9.131 4.015 15.488v.063c.018 6.356 5.181 11.497 11.534 11.488 6.352-.01 11.49-5.164 11.49-11.519S21.9 4.01 15.549 4zm0 1.856c5.292.01 9.572 4.304 9.572 9.599s-4.28 9.59-9.572 9.6c-5.293.01-9.596-4.272-9.614-9.567v-.064c.018-5.296 4.32-9.577 9.614-9.568zm-.021 7.123a2.54 2.54 0 10-.002 5.079 2.54 2.54 0 00.002-5.08z"}));
}

Sun.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Sun;

Sun.default = Sun;
